import parseUtcDate from './parseUtcDate'

const localizeDate = (utcDate?: string | null): string =>
    !utcDate ? '---' : parseUtcDate(utcDate).toLocaleString('sv-SE')

export default localizeDate
